import { Civility } from '../rest/types/User'

const civilityToLabelMap: Record<Civility, string> = {
  [Civility.Mr]: 'Monsieur',
  [Civility.Mrs]: 'Madame',
  [Civility.Dr]: 'Docteur',
}

const labelToCivilityMap: Record<string, Civility | undefined> = {
  Monsieur: Civility.Mr,
  Madame: Civility.Mrs,
  Docteur: Civility.Dr,
}

export function civilityEnumToLabel(value?: Civility | string | null): string {
  if (!value) return ''
  if (typeof value !== 'string') return ''
  const normalized = value.toLowerCase() as Civility
  return civilityToLabelMap[normalized as Civility] ?? ''
}

export function civilityLabelToEnum(label?: string | null): Civility | '' {
  if (!label) return ''
  const mapped = labelToCivilityMap[label]
  return mapped ?? ''
}

export function civilityOptionsFromEnumValues(
  values: Civility[]
): Array<{ label: string; value: Civility }> {
  return values.map((v) => ({ label: civilityEnumToLabel(v), value: v }))
}
